<fieldset>
    <label class="sa-form-label" style="margin-right:10px">{{title}}</label>
    <div *ngFor="let type of types" style="display:inline-block;margin-right:20px">
        <input type="radio" id="{{type}}" name="{{type}}" [(ngModel)]="selectedType" value="{{type}}" (change)="change()">
        <label for="gps" style="margin-left:5px">{{type}}</label>
    </div>
  </fieldset>
